<template>
  <section class="chapter5">
    <div class="container">
      <Count>5</Count>
      <Title light>Je telefoon als pashokje</Title>
      <Content light>
        <p>Voor bedrijven als Zalando, Wehkamp en de Bijenkorf drukken retourkosten enorm op de begroting - en vooral de winst. Maar ja, in de moordende markt van kleding bestellen is gratis retourneren enorm belangrijk. De extra klanten die je daarmee binnenhaalt, maken het voorlopig de moeite waard, blijkt uit onderzoek.</p>
        <p>De vraag is wel wat er gaat gebeuren als de groei afneemt, of al die retouren nog wel houdbaar zijn - qua kosten en duurzaamheid. Daarom doen bedrijven er alles aan om het online passen te moderniseren. Hoe beter jij van tevoren kan bepalen welke maat je nodig hebt en hoe die nieuwe jas staat, hoe minder je terugstuurt. Hoe gaan we in de toekomst online onze kleding passen?</p>
      </Content>
    </div>
    <CircleCards />
    <div class="container">
      <Content light>
        <p>Webshops en bezorgdiensten zullen zich dus blijven vernieuwen om nóg beter op onze besteldrift in te spelen. En terwijl dat gebeurt, draait de pakjeseconomie op volle (re)toeren door.</p>
      </Content>
    </div>
  </section>
</template>

<script>
import { Title, Count, Content } from '@/components/chapter'
import CircleCards from '@/components/circle-cards'
import { chapterMixin } from '@/mixins'

export default {
  name: 'Chapter5',
  mixins: [chapterMixin],
  components: {
    Title,
    Count,
    Content,
    CircleCards
  }
}
</script>

<style lang="scss" scoped>
.chapter5 {
  background-color: white;
  padding-top: 5em;
  padding-bottom: 5em;

  @media (max-width: 767px) {
    padding-top: 4em;
    padding-bottom: 4em;
  }
}
</style>
